import { MetaInfo } from 'vue-meta/types/vue-meta';

export interface HeadInput {
  title: string;
  description?: string;
}

export function makeMetaInfo({ title, description }: HeadInput): MetaInfo {
  const metaTags: MetaInfo['meta'] = [];

  if (title) {
    title = title + ' - プロフ（Proff） | スマート履歴書';

    metaTags.push(
      {
        property: 'og:title',
        content: title,
      },
      {
        name: 'twitter:title',
        content: title,
      }
    );
    metaTags.push();
  } else {
    title = '新規登録 - プロフ（Proff） | スマート履歴書';
  }

  if (description) {
    metaTags.push(
      {
        name: 'description',
        content: description,
      },
      {
        property: 'og:description',
        content: description,
      },
      {
        name: 'twitter:description',
        content: description,
      }
    );
  } else {
    description = 'プロフの登録はこちらから。';
    metaTags.push({
      name: 'description',
      content: description,
    });
  }

  return {
    title,
    meta: metaTags,
  };
}
